import { render, staticRenderFns } from "./vIcon.vue?vue&type=template&id=3f5e0800"
import script from "./vIcon.vue?vue&type=script&lang=js"
export * from "./vIcon.vue?vue&type=script&lang=js"
import style0 from "./vIcon.vue?vue&type=style&index=0&id=3f5e0800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports